import request from '@utils/request'

export function fetchPolicies(params) {
  return request({
    url: `/admin/affiliate/policy`,
    params,
  })
}

export function fetchPolicy(seq) {
  return request({
    url: `/admin/affiliate/policy/${seq || 0}`,
    method: 'get',
  })
}

export function fetchLogList(params) {
  return request({
    url: '/admin/affiliate/log',
    method: 'get',
    params,
  })
}

export function fetchBalanceList(params) {
  return request({
    url: '/admin/affiliate/balance',
    method: 'get',
    params,
  })
}

export function fetchAdjustList(params) {
  return request({
    url: '/admin/affiliate/adjust',
    method: 'get',
    params,
  })
}

export function fetchPolicyMemberList(params) {
  return request({
    url: '/admin/affiliate/policy-member',
    method: 'get',
    params,
  })
}

export function createAdjust(data) {
  return request.post('/admin/affiliate/adjust', data)
}

export function createPolicy(data) {
  return request.post('/admin/affiliate/policy', data)
}

export function updatePolicy(data) {
  return request.put(`/admin/affiliate/policy/${data.seq}`, data)
}

export function deletePolicy(seq) {
  return request.delete(`/admin/affiliate/policy/${seq}`)
}

export function fetchPolicyCauserConditions(policy_seq) {
  return request({
    url: `/admin/affiliate/policy/${policy_seq || 0}/causer-condition`,
  })
}

export function fetchPolicyCauserCondition(policy_seq, seq) {
  return request({
    url: `/admin/affiliate/policy/${policy_seq || 0}/causer-condition/${seq ||
      0}`,
    method: 'get',
  })
}

export function createPolicyCauserCondition({ policy_seq, ...data }) {
  return request.post(
    `/admin/affiliate/policy/${policy_seq || 0}/causer-condition/`,
    data
  )
}

export function updatePolicyCauserCondition({ policy_seq, seq, ...data }) {
  return request.put(
    `/admin/affiliate/policy/${policy_seq || 0}/causer-condition/${seq}`,
    data
  )
}

export function deletePolicyCauserCondition(policy_seq, seq) {
  return request.delete(
    `/admin/affiliate/policy/${policy_seq || 0}/causer-condition/${seq}`
  )
}

export function fetchPolicyActionConditions(policy_seq) {
  return request({
    url: `/admin/affiliate/policy/${policy_seq || 0}/action-condition`,
  })
}

export function fetchPolicyActionCondition(policy_seq, seq) {
  return request({
    url: `/admin/affiliate/policy/${policy_seq || 0}/action-condition/${seq ||
      0}`,
    method: 'get',
  })
}

export function createPolicyActionCondition({ policy_seq, ...data }) {
  return request.post(
    `/admin/affiliate/policy/${policy_seq || 0}/action-condition/`,
    data
  )
}

export function updatePolicyActionCondition({ policy_seq, seq, ...data }) {
  return request.put(
    `/admin/affiliate/policy/${policy_seq || 0}/action-condition/${seq}`,
    data
  )
}

export function deletePolicyActionCondition(policy_seq, seq) {
  return request.delete(
    `/admin/affiliate/policy/${policy_seq || 0}/action-condition/${seq}`
  )
}

export function fetchPolicyBeneficiaries(policy_seq) {
  return request({
    url: `/admin/affiliate/policy/${policy_seq || 0}/beneficiary`,
  })
}

export function fetchPolicyBeneficiary(policy_seq, seq) {
  return request({
    url: `/admin/affiliate/policy/${policy_seq || 0}/beneficiary/${seq || 0}`,
    method: 'get',
  })
}

export function createPolicyBeneficiary({ policy_seq, ...data }) {
  return request.post(
    `/admin/affiliate/policy/${policy_seq || 0}/beneficiary/`,
    data
  )
}

export function updatePolicyBeneficiary({ policy_seq, seq, ...data }) {
  return request.put(
    `/admin/affiliate/policy/${policy_seq || 0}/beneficiary/${seq}`,
    data
  )
}

export function deletePolicyBeneficiary(policy_seq, seq) {
  return request.delete(
    `/admin/affiliate/policy/${policy_seq || 0}/beneficiary/${seq}`
  )
}

export function fetchPolicyBeneficiaryConditions(policy_seq, beneficiary_seq) {
  return request({
    url: `/admin/affiliate/policy/${policy_seq ||
      0}/beneficiary/${beneficiary_seq || 0}/condition`,
  })
}

export function fetchPolicyBeneficiaryCondition(
  policy_seq,
  beneficiary_seq,
  seq
) {
  return request({
    url: `/admin/affiliate/policy/${policy_seq ||
      0}/beneficiary/${beneficiary_seq || 0}/condition/${seq || 0}`,
    method: 'get',
  })
}

export function createPolicyBeneficiaryCondition({
  policy_seq,
  beneficiary_seq,
  ...data
}) {
  return request.post(
    `/admin/affiliate/policy/${policy_seq || 0}/beneficiary/${beneficiary_seq ||
      0}/condition`,
    data
  )
}

export function updatePolicyBeneficiaryCondition({
  policy_seq,
  beneficiary_seq,
  seq,
  ...data
}) {
  return request.put(
    `/admin/affiliate/policy/${policy_seq || 0}/beneficiary/${beneficiary_seq ||
      0}/condition/${seq}`,
    data
  )
}

export function deletePolicyBeneficiaryCondition(
  policy_seq,
  beneficiary_seq,
  seq
) {
  return request.delete(
    `/admin/affiliate/policy/${policy_seq || 0}/beneficiary/${beneficiary_seq ||
      0}/condition/${seq}`
  )
}

export function fetchPolicyBenefactors(policy_seq, beneficiary_seq) {
  return request({
    url: `/admin/affiliate/policy/${policy_seq ||
      0}/beneficiary/${beneficiary_seq || 0}/benefactor`,
  })
}

export function fetchPolicyBenefactor(policy_seq, beneficiary_seq, seq) {
  return request({
    url: `/admin/affiliate/policy/${policy_seq ||
      0}/beneficiary/${beneficiary_seq || 0}/benefactor/${seq || 0}`,
    method: 'get',
  })
}

export function createPolicyBenefactor({
  policy_seq,
  beneficiary_seq,
  ...data
}) {
  return request.post(
    `/admin/affiliate/policy/${policy_seq || 0}/beneficiary/${beneficiary_seq ||
      0}/benefactor`,
    data
  )
}

export function updatePolicyBenefactor({
  policy_seq,
  beneficiary_seq,
  seq,
  ...data
}) {
  return request.put(
    `/admin/affiliate/policy/${policy_seq || 0}/beneficiary/${beneficiary_seq ||
      0}/benefactor/${seq}`,
    data
  )
}

export function deletePolicyBenefactor(policy_seq, beneficiary_seq, seq) {
  return request.delete(
    `/admin/affiliate/policy/${policy_seq || 0}/beneficiary/${beneficiary_seq ||
      0}/benefactor/${seq}`
  )
}

export function createPolicyMember(data) {
  return request.post('/admin/affiliate/policy-member', data)
}

export function deletePolicyMember(seq) {
  return request.delete(`/admin/affiliate/policy-member/${seq}`)
}
